import Vue from 'vue';
import { secureStorage } from '@/utils/secure-storage';

export default {
  namespaced: true,
  state: {
    offer_count: 0,
    page_count: 0,
    offers: [],
    lastTimeStamp: -1,

    // Query
    limit: 20, // NOTE (SG) 4 rows of 5 by default
    currentPage: 1,
    keyword: null,
    promotion_only: false,
    promotion_sold_out: false,

    regionOptions: ['ca', 'qc', 'on', 'nb', 'ab', 'nl'],
    currentRegion: secureStorage.getItem('hello::currentRegion') ? secureStorage.getItem('hello::currentRegion').toLowerCase() : undefined,
  },
  getters: {
    offers: (state) => state.offers,
    dataIsAlreadyLoaded: (state) => state.currentPage !== 1,
    regionOptions: (state) => state.regionOptions,
    currentRegion: (state) => state.currentRegion,
    promotionOnly: (state) => state.promotion_only,
    promotionSoldOut: (state) => state.promotion_sold_out,
    searchKeyword: (state) => state.keyword,
    canLoadMore: (state) => state.currentPage + 1 <= state.page_count,
  },
  mutations: {
    setCurrentRegion: (state, currentRegion) => {
      state.currentRegion = currentRegion;
    },
    setPromotionOnly: (state, promotionOnly) => {
      state.promotion_only = promotionOnly;
    },
    setPromotionSoldOut: (state, promotionSoldOut) => {
      state.promotion_sold_out = promotionSoldOut;
    },
    setOffers: (state, offers) => {
      if (state.lastTimeStamp < offers.initialCallTimestamp) {
        state.offers = offers.items;
        state.offer_count = offers.item_count;
        state.page_count = offers.page_count;
        state.lastTimeStamp = offers.initialCallTimestamp;
      }
    },
    appendOffers: (state, offer) => {
      state.offers.splice(state.offers.length, 0, ...offer.items);
    },
    setKeyword: (state, keyword) => {
      state.keyword = keyword;
    },
    setPage: (state, page) => {
      state.currentPage = page;
    },

    reset(state) {
      state.offers = [];
      state.offer_count = 0;
      state.page_count = 0;
      state.currentPage = 1;
      state.lastTimeStamp = -1;
    },
  },
  actions: {
    updateRegion({ commit }, region) {
      secureStorage.setItem('hello::currentRegion', region);
      commit('setCurrentRegion', region);
    },
    updatePromotionSoldOut({ commit }, promotion_sold_out) {
      commit('setPromotionSoldOut', promotion_sold_out);
    },
    updatePromotionOnly({ commit }, promotion_only) {
      commit('setPromotionOnly', promotion_only);
    },
    updateSearchKeyword({ commit }, keyword) {
      commit('setKeyword', keyword);
    },
    nextPage({ commit, state }) {
      commit('setPage', state.currentPage + 1);
    },
    async searchGiftCertificate({ commit, state, getters }, { locale = 'fr', reset = false }) {
      if (reset) {
        commit('setPage', 1);
      }

      let region_to_include;
      if (getters.currentRegion) {
        region_to_include = getters.currentRegion.toUpperCase() !== 'CA' ? [getters.currentRegion.toUpperCase()] : ['qc', 'on', 'nb', 'ab', 'nl'];
      }

      const initialCallTimestamp = Date.now();
      const offerList = await Vue.prototype.$services.offer.listGiftCertificateOffer(locale, state.currentPage, state.limit, state.keyword, region_to_include, state.promotion_only, state.promotion_sold_out);

      if (state.currentPage !== 1) {
        commit('appendOffers', offerList);
      } else {
        commit('setOffers', { initialCallTimestamp, ...offerList });
      }
      return offerList;
    },
  },
};
